export enum AccessYourSuperPaymentTypeEnum {
    FullAmountCloseAccount = 1,
    FullAmountKeepAccountOpen = 2,
    PartialAmount = 3,
    FullAmountRestrictedNonPreserved = 4,
    FullPensionLumpSumBenefitCloseAccount = 5,
    FullGrossAmountTenThousand = 6,
    FullAmountEntireUnrp = 7,
    FullAmountEntireUnrpKeepAccountOpen = 8
}